import axios from 'axios'
import { errorHandler, getUrl } from './utils/http-helpers'

export class LicenseUtil {
  /*
   *  try to get license locally without credential
   */
  static async tryLocal (app) {
    const url = getUrl('/license/' + app)
    let result = null
    await axios.get(url)
      .then(resp => {
        if (resp) {
          // console.log('[DEBUG] License.tryLocal() response:', resp.data)
          result = resp.data
        }
      })
      .catch(e => {
        errorHandler(e)
        console.log('[ERROR] License.tryLocal()', e)
      })
    return result
  }

  static tryLocalAsync (app) {
    const url = getUrl('/license/' + app)
    return axios.get(url)
  }

  static isValid (lic) {
    return (lic && lic.licenseKey && lic.licenseKey !== '')
  }

  static async get (app, user, pwd) {
    const up64 = window.btoa(user + ':' + pwd)
    const url = getUrl('/license/' + app)
    const config = {
      headers: {
        Authorization: 'Basic ' + up64
      }
    }
    console.log('[DEBUG] license url:', url)
    console.log('[DEBUG] license header:', config.headers)
    let result = null
    await axios.get(url, config)
      .then(resp => {
        if (resp) {
          console.log('[DEBUG] License.get() response:', resp.data)
          result = resp.data
        }
      })
      .catch(e => {
        errorHandler(e)
        console.log('[ERROR] License.get()', e)
      })
    return result
  }

  static async verifyKey (licenseKey, app) {
    const url = getUrl(`/license/${app}/${licenseKey}`)
    let result = false
    await axios.put(url)
      .then(resp => {
        if (resp) {
          console.log('[DEBUG] License.verifyKey() response:', resp.data)
          result = resp.data
        }
      })
      .catch(e => {
        errorHandler(e)
        console.log('[ERROR] License.verifyKey()', e)
      })
    return result
  }

  static async startTrial (app) {
    const url = getUrl(`/license-trial/${app}`)
    let result = null
    await axios.post(url)
      .then(resp => {
        if (resp) {
          console.log('[DEBUG] License.startTrial() response:', resp.data)
          result = resp.data
        }
      })
      .catch(e => {
        errorHandler(e)
        console.log('[ERROR] License.startTrial()', e)
      })
    return result
  }

  // put '-' delimiter every 'n' chars
  static group (input, n) {
    if (n <= 0) return input
    let tmp = ''
    for (let i = 1; i <= input.length; i++) {
      tmp += input[i - 1]
      if ((i < input.length) && (i % n === 0)) {
        tmp += '-'
      }
    }
    return tmp
  }

  static async getHardwareKey (app) {
    const url = getUrl(`/license-check/${app}`)
    let result = ''
    await axios.get(url)
      .then(resp => {
        if (resp && resp.data) {
          result = resp.data.HardwareKey
        }
      })
      .catch(e => {
        errorHandler(e)
        console.log('[ERROR] License.getHardwareKey()', e)
      })
    return result
  }
}
